import dayjs from 'dayjs'

const easternYmd = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

/**
 * The US Eastern calendar day of an instant, as a local-midnight dayjs. The backend files each shiur under its
 * Eastern publication day, so the Daily Shiurim page groups by the same day regardless of the viewer's zone.
 */
export const getEasternDate = (date: string | Date) => dayjs(easternYmd.format(new Date(date)))
